<template>
  <div class="h-screen overflow-y-auto bg-gray-50 px-4 py-10 pb-24 scrollable-page">

    <div class="profile-tab-content max-w-lg mx-auto flex flex-col justify-between" :class="{ 'profile-skeleton-group': pageLoading }">

      <!-- Header -->
      <div class="pb-8">
        <div v-if="pageLoading" class="text-center" aria-hidden="true">
          <div class="skeleton-block skeleton-avatar mx-auto"></div>
          <div class="skeleton-block skeleton-line skeleton-line-lg mx-auto mt-3"></div>
          <div class="skeleton-block skeleton-line skeleton-line-sm mx-auto mt-2"></div>
        </div>
        <div v-else class="text-center">
          <div class="relative inline-block">
            <div class="w-20 h-20 rounded-full overflow-hidden border border-gray-200 mx-auto">
              <img :src="ThumbnailPath" class="w-full h-full object-cover" alt="Profile" />
            </div>
          </div>
          <div class="text-lg font-bold mt-2">{{ user_name }}</div>
          <p class="text-gray-500 mt-1 text-sm" dir="ltr">{{ user_mobile }}</p>
        </div>

        <!-- Branch Info Card -->
        <div v-if="pageLoading" class="skeleton-block skeleton-branch-card my-4" aria-hidden="true"></div>
        <div v-else class="bg-white border border-gray-150 rounded-xl py-4 px-5 my-4">
          <div class="text-center flex gap-2 justify-between items-center">
            <div class="text-sm">{{ role_title }}</div>
            <div class="flex gap-2 items-center justify-center cursor-pointer" @click="$router.push({path:'/survey_report'})">
              <span class="text-sm font-medium">رتبه: {{ rating }}</span>
              <svg width="20" height="20" viewBox="0 -0.5 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16.0005 0L21.4392 9.27275L32.0005 11.5439L24.8005 19.5459L25.889 30.2222L16.0005 25.895L6.11194 30.2222L7.20049 19.5459L0.000488281 11.5439L10.5618 9.27275L16.0005 0Z" fill="#FFCB45"/>
              </svg>
            </div>
            <p class="text-sm">{{ branch_name }}</p>
          </div>
        </div>
      </div>

      <!-- Action Buttons Grid -->
      <div v-if="pageLoading" class="bg-white border border-gray-150 rounded-xl overflow-hidden" aria-hidden="true">
        <div
          v-for="n in skeletonMenuCount"
          :key="'profile-sk-menu-' + n"
          class="px-4"
          :class="{ 'pt-4': n === 1 }"
        >
          <div class="flex gap-4 items-center py-3" :class="{ 'border-t border-gray-200': n > 1 }">
            <div class="skeleton-block skeleton-menu-icon"></div>
            <div class="skeleton-block skeleton-line skeleton-line-menu flex-grow"></div>
          </div>
        </div>
      </div>
      <div v-else class="grid bg-white border border-gray-150 rounded-xl ">
        <!-- Contacts -->
          <div class="p-4  cursor-pointer  " @click="goToContacts()">
            <div class="flex  gap-4 items-center w-full text-center ">
              <div class="p-2  bg-blue-100 rounded-xl flex items-center justify-center">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="9" r="3" stroke="#007AFF" stroke-width="1.5"/>
                <path d="M17.9691 20C17.81 17.1085 16.9247 15 11.9999 15C7.07521 15 6.18991 17.1085 6.03076 20" stroke="#007AFF" stroke-width="1.5" stroke-linecap="round"/>
                <path d="M7 3.33782C8.47087 2.48697 10.1786 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 10.1786 2.48697 8.47087 3.33782 7" stroke="#007AFF" stroke-width="1.5" stroke-linecap="round"/>
                </svg>
              </div>
              <span class="text-gray-700 text-sm font-medium w-full text-right">{{ $t('contacts') }}</span>
          </div>
        </div>

        <!-- Saved Messages -->
          <div class="px-4 cursor-pointer " @click="goToSavedMessage()">
            <div class="flex  gap-4 items-center w-full text-center border-t border-gray-200 py-3">
              <div class="bg-green-100 p-2  rounded-xl flex items-center justify-center">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M13.0867 21.3877L13.7321 21.7697L13.0867 21.3877ZM13.6288 20.4718L12.9833 20.0898L13.6288 20.4718ZM10.3712 20.4718L9.72579 20.8539H9.72579L10.3712 20.4718ZM10.9133 21.3877L11.5587 21.0057L10.9133 21.3877ZM1.25 10.5C1.25 10.9142 1.58579 11.25 2 11.25C2.41421 11.25 2.75 10.9142 2.75 10.5H1.25ZM3.07351 15.6264C2.915 15.2437 2.47627 15.062 2.09359 15.2205C1.71091 15.379 1.52918 15.8177 1.68769 16.2004L3.07351 15.6264ZM7.78958 18.9915L7.77666 19.7413L7.78958 18.9915ZM5.08658 18.6194L4.79957 19.3123H4.79957L5.08658 18.6194ZM21.6194 15.9134L22.3123 16.2004V16.2004L21.6194 15.9134ZM16.2104 18.9915L16.1975 18.2416L16.2104 18.9915ZM18.9134 18.6194L19.2004 19.3123H19.2004L18.9134 18.6194ZM19.6125 2.7368L19.2206 3.37628L19.6125 2.7368ZM21.2632 4.38751L21.9027 3.99563V3.99563L21.2632 4.38751ZM4.38751 2.7368L3.99563 2.09732V2.09732L4.38751 2.7368ZM2.7368 4.38751L2.09732 3.99563H2.09732L2.7368 4.38751ZM9.40279 19.2098L9.77986 18.5615L9.77986 18.5615L9.40279 19.2098ZM13.7321 21.7697L14.2742 20.8539L12.9833 20.0898L12.4412 21.0057L13.7321 21.7697ZM9.72579 20.8539L10.2679 21.7697L11.5587 21.0057L11.0166 20.0898L9.72579 20.8539ZM12.4412 21.0057C12.2485 21.3313 11.7515 21.3313 11.5587 21.0057L10.2679 21.7697C11.0415 23.0767 12.9585 23.0767 13.7321 21.7697L12.4412 21.0057ZM10.5 2.75H13.5V1.25H10.5V2.75ZM21.25 10.5V11.5H22.75V10.5H21.25ZM7.8025 18.2416C6.54706 18.2199 5.88923 18.1401 5.37359 17.9265L4.79957 19.3123C5.60454 19.6457 6.52138 19.7197 7.77666 19.7413L7.8025 18.2416ZM1.68769 16.2004C2.27128 17.6093 3.39066 18.7287 4.79957 19.3123L5.3736 17.9265C4.33223 17.4951 3.50486 16.6678 3.07351 15.6264L1.68769 16.2004ZM21.25 11.5C21.25 12.6751 21.2496 13.5189 21.2042 14.1847C21.1592 14.8438 21.0726 15.2736 20.9265 15.6264L22.3123 16.2004C22.5468 15.6344 22.6505 15.0223 22.7007 14.2868C22.7504 13.5581 22.75 12.6546 22.75 11.5H21.25ZM16.2233 19.7413C17.4786 19.7197 18.3955 19.6457 19.2004 19.3123L18.6264 17.9265C18.1108 18.1401 17.4529 18.2199 16.1975 18.2416L16.2233 19.7413ZM20.9265 15.6264C20.4951 16.6678 19.6678 17.4951 18.6264 17.9265L19.2004 19.3123C20.6093 18.7287 21.7287 17.6093 22.3123 16.2004L20.9265 15.6264ZM13.5 2.75C15.1512 2.75 16.337 2.75079 17.2619 2.83873C18.1757 2.92561 18.7571 3.09223 19.2206 3.37628L20.0044 2.09732C19.2655 1.64457 18.4274 1.44279 17.4039 1.34547C16.3915 1.24921 15.1222 1.25 13.5 1.25V2.75ZM22.75 10.5C22.75 8.87781 22.7508 7.6085 22.6545 6.59611C22.5572 5.57256 22.3554 4.73445 21.9027 3.99563L20.6237 4.77938C20.9078 5.24291 21.0744 5.82434 21.1613 6.73809C21.2492 7.663 21.25 8.84876 21.25 10.5H22.75ZM19.2206 3.37628C19.7925 3.72672 20.2733 4.20752 20.6237 4.77938L21.9027 3.99563C21.4286 3.22194 20.7781 2.57144 20.0044 2.09732L19.2206 3.37628ZM10.5 1.25C8.87781 1.25 7.6085 1.24921 6.59611 1.34547C5.57256 1.44279 4.73445 1.64457 3.99563 2.09732L4.77938 3.37628C5.24291 3.09223 5.82434 2.92561 6.73809 2.83873C7.663 2.75079 8.84876 2.75 10.5 2.75V1.25ZM2.75 10.5C2.75 8.84876 2.75079 7.663 2.83873 6.73809C2.92561 5.82434 3.09223 5.24291 3.37628 4.77938L2.09732 3.99563C1.64457 4.73445 1.44279 5.57256 1.34547 6.59611C1.24921 7.6085 1.25 8.87781 1.25 10.5H2.75ZM3.99563 2.09732C3.22194 2.57144 2.57144 3.22194 2.09732 3.99563L3.37628 4.77938C3.72672 4.20752 4.20752 3.72672 4.77938 3.37628L3.99563 2.09732ZM11.0166 20.0898C10.8136 19.7468 10.6354 19.4441 10.4621 19.2063C10.2795 18.9559 10.0702 18.7304 9.77986 18.5615L9.02572 19.8582C9.07313 19.8857 9.13772 19.936 9.24985 20.0898C9.37122 20.2564 9.50835 20.4865 9.72579 20.8539L11.0166 20.0898ZM7.77666 19.7413C8.21575 19.7489 8.49387 19.7545 8.70588 19.7779C8.90399 19.7999 8.98078 19.832 9.02572 19.8582L9.77986 18.5615C9.4871 18.3912 9.18246 18.3215 8.87097 18.287C8.57339 18.2541 8.21375 18.2487 7.8025 18.2416L7.77666 19.7413ZM14.2742 20.8539C14.4916 20.4865 14.6287 20.2564 14.7501 20.0898C14.8622 19.936 14.9268 19.8857 14.9742 19.8582L14.2201 18.5615C13.9298 18.7304 13.7204 18.9559 13.5379 19.2063C13.3646 19.4441 13.1864 19.7468 12.9833 20.0898L14.2742 20.8539ZM16.1975 18.2416C15.7862 18.2487 15.4266 18.2541 15.129 18.287C14.8175 18.3215 14.5129 18.3912 14.2201 18.5615L14.9742 19.8582C15.0192 19.832 15.096 19.7999 15.2941 19.7779C15.5061 19.7545 15.7842 19.7489 16.2233 19.7413L16.1975 18.2416Z" fill="#458242"/>
                  <path d="M8 11H8.009M11.991 11H12M15.991 11H16" stroke="#458242" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>  
              </div>
              <span class="text-gray-700 text-sm font-medium w-full text-right">{{ $t('savedMessage') }}</span>
          </div>
        </div>

        <!-- Settings -->
          <div class="px-4  cursor-pointer " @click="goToSetting()">
            <div class="flex  gap-4 items-center w-full text-center  border-t border-gray-200 py-3">
              <div class="bg-purple-100 p-2  rounded-xl flex items-center justify-center ">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.84308 20.1979C9.8718 21.3993 10.8862 22 12 22C13.1138 22 14.1282 21.3993 16.1569 20.1979L16.8431 19.7915C18.8718 18.5901 19.8862 17.9894 20.4431 17C21 16.0106 21 14.8092 21 12.4063M20.8147 8C20.7326 7.62759 20.6141 7.3038 20.4431 7C19.8862 6.01057 18.8718 5.40987 16.8431 4.20846L16.1569 3.80211C14.1282 2.6007 13.1138 2 12 2C10.8862 2 9.8718 2.6007 7.84308 3.80211L7.15692 4.20846C5.1282 5.40987 4.11384 6.01057 3.55692 7C3 7.98943 3 9.19084 3 11.5937V12.4063C3 14.8092 3 16.0106 3.55692 17C3.78326 17.4021 4.08516 17.74 4.5 18.0802" stroke="#9B49B2" stroke-width="1.5" stroke-linecap="round"/>
                <circle cx="12" cy="12" r="3" stroke="#9B49B2" stroke-width="1.5"/>
                </svg>
              </div>
              <span class="text-gray-700 text-sm font-medium w-full text-right">{{ $t('settings') }}</span>
          </div>
        </div>

        <!-- Contact Us -->
          <div class="px-4  cursor-pointer " @click="goToContact()">
            <div class="flex  gap-4 items-center w-full text-center  border-t border-gray-200 py-3">
              <div class="bg-orange-100 p-2 rounded-xl flex items-center justify-center">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13.5 2C13.5 2 15.8335 2.21213 18.8033 5.18198C21.7731 8.15183 21.9853 10.4853 21.9853 10.4853" stroke="#D88500" stroke-width="1.5" stroke-linecap="round"/>
                <path d="M14.207 5.53564C14.207 5.53564 15.197 5.81849 16.6819 7.30341C18.1668 8.78834 18.4497 9.77829 18.4497 9.77829" stroke="#D88500" stroke-width="1.5" stroke-linecap="round"/>
                <path d="M15.1008 15.0272L15.6446 15.5437V15.5437L15.1008 15.0272ZM15.5562 14.5477L15.0124 14.0312V14.0312L15.5562 14.5477ZM17.9729 14.2123L17.5987 14.8623H17.5987L17.9729 14.2123ZM19.8834 15.312L19.5092 15.962L19.8834 15.312ZM20.4217 18.7584L20.9655 19.275L20.9655 19.2749L20.4217 18.7584ZM19.0012 20.254L18.4574 19.7375L19.0012 20.254ZM17.6763 20.9631L17.75 21.7095L17.6763 20.9631ZM7.8154 16.4752L8.3592 15.9587L7.8154 16.4752ZM3.75185 6.92574C3.72965 6.51212 3.37635 6.19481 2.96273 6.21701C2.54911 6.23921 2.23181 6.59252 2.25401 7.00613L3.75185 6.92574ZM9.19075 8.80507L9.73454 9.32159L9.19075 8.80507ZM9.47756 8.50311L10.0214 9.01963L9.47756 8.50311ZM9.63428 5.6931L10.2467 5.26012L9.63428 5.6931ZM8.3733 3.90961L7.7609 4.3426V4.3426L8.3733 3.90961ZM4.7177 3.09213C4.43244 3.39246 4.44465 3.86717 4.74498 4.15244C5.04531 4.4377 5.52002 4.42549 5.80529 4.12516L4.7177 3.09213ZM11.0632 13.0559L11.607 12.5394L11.0632 13.0559ZM10.6641 19.8123C11.0148 20.0327 11.4778 19.9271 11.6982 19.5764C11.9186 19.2257 11.8129 18.7627 11.4622 18.5423L10.6641 19.8123ZM15.113 20.0584C14.7076 19.9735 14.3101 20.2334 14.2252 20.6388C14.1403 21.0442 14.4001 21.4417 14.8056 21.5266L15.113 20.0584ZM15.6446 15.5437L16.1 15.0642L15.0124 14.0312L14.557 14.5107L15.6446 15.5437ZM17.5987 14.8623L19.5092 15.962L20.2575 14.662L18.347 13.5623L17.5987 14.8623ZM19.8779 18.2419L18.4574 19.7375L19.545 20.7705L20.9655 19.275L19.8779 18.2419ZM8.3592 15.9587C4.48307 11.8778 3.83289 8.43556 3.75185 6.92574L2.25401 7.00613C2.35326 8.85536 3.13844 12.6403 7.27161 16.9917L8.3592 15.9587ZM9.73454 9.32159L10.0214 9.01963L8.93377 7.9866L8.64695 8.28856L9.73454 9.32159ZM10.2467 5.26012L8.98569 3.47663L7.7609 4.3426L9.02189 6.12608L10.2467 5.26012ZM9.19075 8.80507C8.64695 8.28856 8.64626 8.28929 8.64556 8.29002C8.64533 8.29028 8.64463 8.29102 8.64415 8.29152C8.6432 8.29254 8.64223 8.29357 8.64125 8.29463C8.63928 8.29675 8.63724 8.29896 8.63515 8.30127C8.63095 8.30588 8.6265 8.31087 8.62182 8.31625C8.61247 8.32701 8.60219 8.33931 8.5912 8.3532C8.56922 8.38098 8.54435 8.41511 8.51826 8.45588C8.46595 8.53764 8.40921 8.64531 8.36117 8.78033C8.26346 9.0549 8.21022 9.4185 8.27675 9.87257C8.40746 10.7647 8.99202 11.9644 10.5194 13.5724L11.607 12.5394C10.1793 11.0363 9.82765 10.1106 9.7609 9.65511C9.72871 9.43536 9.76142 9.31957 9.77436 9.28321C9.78163 9.26277 9.78639 9.25709 9.78174 9.26437C9.77948 9.26789 9.77498 9.27451 9.76742 9.28407C9.76363 9.28885 9.75908 9.29437 9.75364 9.30063C9.75092 9.30375 9.74798 9.30706 9.7448 9.31056C9.74321 9.31231 9.74156 9.3141 9.73985 9.31594C9.739 9.31686 9.73813 9.31779 9.73724 9.31873C9.7368 9.3192 9.73612 9.31992 9.7359 9.32015C9.73522 9.32087 9.73454 9.32159 9.19075 8.80507ZM10.5194 13.5724C12.0422 15.1757 13.1924 15.806 14.0699 15.9485C14.5201 16.0216 14.8846 15.9632 15.1606 15.8544C15.2955 15.8012 15.4023 15.7387 15.4824 15.6819C15.5223 15.6535 15.5556 15.6266 15.5825 15.6031C15.5959 15.5913 15.6078 15.5803 15.6181 15.5703C15.6233 15.5654 15.628 15.5606 15.6324 15.5562C15.6346 15.554 15.6368 15.5518 15.6388 15.5497C15.6398 15.5487 15.6408 15.5477 15.6417 15.5467C15.6422 15.5462 15.6429 15.5454 15.6432 15.5452C15.6439 15.5444 15.6446 15.5437 15.1008 15.0272C14.557 14.5107 14.5577 14.51 14.5583 14.5093C14.5586 14.509 14.5592 14.5083 14.5597 14.5078C14.5606 14.5069 14.5615 14.506 14.5623 14.5051C14.5641 14.5033 14.5658 14.5015 14.5675 14.4998C14.5708 14.4965 14.574 14.4933 14.577 14.4904C14.5831 14.4846 14.5885 14.4796 14.5933 14.4754C14.6029 14.467 14.61 14.4616 14.6146 14.4584C14.6239 14.4517 14.623 14.454 14.6102 14.459C14.5909 14.4666 14.5001 14.4987 14.3103 14.4679C13.9078 14.4025 13.0391 14.0472 11.607 12.5394L10.5194 13.5724ZM8.98569 3.47663C7.9721 2.04305 5.94388 1.80119 4.7177 3.09213L5.80529 4.12516C6.32812 3.57471 7.24855 3.61795 7.7609 4.3426L8.98569 3.47663ZM18.4574 19.7375C18.1783 20.0313 17.8864 20.1887 17.6026 20.2167L17.75 21.7095C18.497 21.6357 19.1016 21.2373 19.545 20.7705L18.4574 19.7375ZM10.0214 9.01963C10.9889 8.00095 11.0574 6.40678 10.2467 5.26012L9.02189 6.12608C9.44404 6.72315 9.3793 7.51753 8.93377 7.9866L10.0214 9.01963ZM19.5092 15.962C20.3301 16.4345 20.4907 17.5968 19.8779 18.2419L20.9655 19.2749C22.2705 17.901 21.8904 15.6019 20.2575 14.662L19.5092 15.962ZM16.1 15.0642C16.4854 14.6584 17.086 14.5672 17.5987 14.8623L18.347 13.5623C17.2485 12.93 15.8862 13.1113 15.0124 14.0312L16.1 15.0642ZM11.4622 18.5423C10.4785 17.9241 9.43149 17.0876 8.3592 15.9587L7.27161 16.9917C8.42564 18.2067 9.56897 19.1241 10.6641 19.8123L11.4622 18.5423ZM17.6026 20.2167C17.0561 20.2707 16.1912 20.2842 15.113 20.0584L14.8056 21.5266C16.0541 21.788 17.0742 21.7762 17.75 21.7095L17.6026 20.2167Z" fill="#D88500"/>
                </svg>
              </div>
              <span class="text-gray-700 text-sm font-medium w-full text-right">{{ $t('contactUs') }}</span>
          </div>
        </div>

        <!-- Change Login Post -->
          <div class="px-4  cursor-pointer " @click="change_post()">
            <div class="flex  gap-4 items-center w-full text-center  border-t border-gray-200 py-3">
              <div class="bg-indigo-100 p-2  rounded-xl flex items-center justify-center">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M17.5 9.50026H9.96155C8.04979 9.50026 6.5 11.05 6.5 12.9618C6.5 14.8736 8.04978 16.4233 9.96154 16.4233H14.5M17.5 9.50026L15.25 7.42334M17.5 9.50026L15.25 11.5772" stroke="#1C274C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M22 12C22 16.714 22 19.0711 20.5355 20.5355C19.0711 22 16.714 22 12 22C7.28595 22 4.92893 22 3.46447 20.5355C2 19.0711 2 16.714 2 12C2 7.28595 2 4.92893 3.46447 3.46447C4.92893 2 7.28595 2 12 2C16.714 2 19.0711 2 20.5355 3.46447C21.5093 4.43821 21.8356 5.80655 21.9449 8" stroke="#1C274C" stroke-width="1.5" stroke-linecap="round"/>
                  </svg>
                   </div>
              <span class="text-gray-700 text-sm font-medium w-full text-right">{{ $t('changeLoginPost') }}</span>
          </div>
        </div>

        <!-- Logout -->
          <div class="px-4  cursor-pointer " @click="logout()">
            <div class="flex  gap-4 items-center w-full text-center  border-t border-gray-200 pt-3 pb-4">
              <div class="bg-red-100 py-2 pl-1.5 pr-2  rounded-xl flex items-center justify-center">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2.00098 11.999L16.001 11.999M16.001 11.999L12.501 8.99902M16.001 11.999L12.501 14.999" stroke="#AC0103" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M9.00195 7C9.01406 4.82497 9.11051 3.64706 9.87889 2.87868C10.7576 2 12.1718 2 15.0002 2L16.0002 2C18.8286 2 20.2429 2 21.1215 2.87868C22.0002 3.75736 22.0002 5.17157 22.0002 8L22.0002 16C22.0002 18.8284 22.0002 20.2426 21.1215 21.1213C20.3531 21.8897 19.1752 21.9862 17 21.9983M9.00195 17C9.01406 19.175 9.11051 20.3529 9.87889 21.1213C10.5202 21.7626 11.4467 21.9359 13 21.9827" stroke="#AC0103" stroke-width="1.5" stroke-linecap="round"/>
                </svg>
              </div>
              <span class="text-gray-700 text-sm font-medium w-full text-right">{{ $t('exit') }}</span>
            </div>
          </div>

        </div>

      <div v-if="pageLoading" class="skeleton-block skeleton-version mx-auto mt-8 mb-4" aria-hidden="true"></div>
      <p v-else class="text-gray-400 text-xs mt-8 text-center w-full mx-auto">نسخه {{ version }}</p>

    </div>






    <!-- Bottom Navigation -->
    <BottomNav v-model="tab"></BottomNav>
  </div>
</template>
<script>

  import {bus} from "../../main";
  import BottomNav from '../../components/BottomNav.vue'
  import { fetchServerVersion } from '../../utils/versionChecker'
  import { skeletonSilentRequest } from '../../utils/skeletonPages'

  export default {
    components: { BottomNav },
    data () {
      return {
        tab: null,
        branch_name: localStorage.getItem('branch_name'),
        user_name: '',
        user_mobile: '',
        user_image: '',
        ThumbnailPath: '',
        role_title: '',
        rating: '',
        version: '',
        pageLoading: true,
        skeletonMenuCount: 6,
      }
    },
    async mounted () {
      try {
        await this.initProfilePage()
      } finally {
        this.pageLoading = false
      }
    },
    methods: {
      async initProfilePage () {
        const user_data = JSON.parse(localStorage.getItem('profile') || '{}')
        this.user_name = user_data.UserName || ''
        this.user_image = user_data.ThumbPath || ''
        this.ThumbnailPath = user_data.ThumbPath || ''
        this.user_mobile = localStorage.getItem('phone') || ''

        const serverVersion = await fetchServerVersion()
        this.version = serverVersion || 'N/A'

        await this.profile()
      },

      async profile () {
        const profile = JSON.parse(localStorage.getItem('profile') || '{}')
        const obj = { Id: profile.UserId }

        try {
          const response = await this.axios.post('https://panel.zoodkomak.com/jetToken/GetTechProfile', obj, skeletonSilentRequest)
          const data = response && response.data && response.data.data ? response.data.data : null
          if (data && data.ThumbnailPath) {
            this.ThumbnailPath = data.ThumbnailPath
          }
          if (data && data.RoleTitle) {
            this.role_title = data.RoleTitle
          }
          if (data && data.UdD) {
            await this.get_survey_avg(data.UdD)
          }
        } catch (e) {
          if (this.errors) {
            this.errors.push(e)
          }
          bus.$emit('show_toast', [2000, e])
        }
      },

      async get_survey_avg (id) {
        const formData = new FormData()
        formData.append('mobile', (this.user_mobile || '').replace('+98', '0'))
        formData.append('id', id)

        try {
          const response = await this.axios.post('https://rpt.zoodkomak.com/api/GetTechAvg', formData, skeletonSilentRequest)
          this.rating = response.data.count
        } catch (e) {
          if (this.errors) {
            this.errors.push(e)
          }
          bus.$emit('show_toast', [2000, e])
        }
      },

      logout () {
        // پاک کردن localStorage
        localStorage.clear()
        
        // پاک کردن sessionStorage
        sessionStorage.clear()
        
        // پاک کردن تمام کوکی‌ها
        document.cookie.split(";").forEach(function(c) {
          document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/")
        })
        
        // پاک کردن کش مرورگر (Service Worker)
        if ('caches' in window) {
          caches.keys().then(function(names) {
            for (let name of names) {
              caches.delete(name)
            }
          })
        }
        
        // لغو ثبت Service Worker
        if ('serviceWorker' in navigator) {
          navigator.serviceWorker.getRegistrations().then(function(registrations) {
            for (let registration of registrations) {
              registration.unregister()
            }
          })
        }
        
        this.$router.push({ name:'login', params:{} })
      },
      change_post () {
        localStorage.setItem('party_id', '')
        this.$router.push({ name:'post_login', params:{} })
      },
      goToSetting () {
        this.$router.push({ name:this.$t('settings'), params:{} })
      },
      goToContacts () {
        this.$router.push({ path: '/contacts', params: {} })
      },
      goToSavedMessage () {
        // this.$router.push({path: '/saved-message', params: {}})
        var user_data = JSON.parse(localStorage.getItem('profile'))
        console.log('user_dat ', user_data)
        const last_chat_detail = {
          RecType: 0,
          UserOrGroupId : user_data.UserId
        }
        localStorage.setItem('lastChat', JSON.stringify(last_chat_detail))
        this.$router.push({ name: this.$t('conversations'), params: {} })
      },
      goToContact () {
        window.open('https://zoodkomak.com/contact-us', '_blank')
      }
    }
  }
</script>
<style scoped>
.scrollable-page {
  -webkit-overflow-scrolling: touch;
}

.profile-tab-content {
  min-height: 0;
}

.profile-skeleton-group {
  position: relative;
  overflow: hidden;
  pointer-events: none;
  user-select: none;
}

.profile-skeleton-group::after {
  content: '';
  position: absolute;
  inset: 0;
  z-index: 1;
  pointer-events: none;
  transform: translateX(-100%);
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.55) 45%,
    rgba(255, 255, 255, 0.65) 55%,
    rgba(255, 255, 255, 0) 100%
  );
  animation: profile-skeleton-shimmer 1.4s ease-in-out infinite;
}

.skeleton-block {
  background-color: #e5e7eb;
}

.skeleton-avatar {
  width: 5rem;
  height: 5rem;
  border-radius: 50%;
}

.skeleton-line {
  border-radius: 6px;
}

.skeleton-line-lg {
  width: 8rem;
  height: 1.125rem;
}

.skeleton-line-sm {
  width: 6rem;
  height: 0.875rem;
}

.skeleton-line-menu {
  height: 0.875rem;
}

.skeleton-branch-card {
  min-height: 3.5rem;
  border-radius: 0.75rem;
}

.skeleton-menu-icon {
  width: 2.25rem;
  height: 2.25rem;
  border-radius: 0.75rem;
  flex-shrink: 0;
}

.skeleton-version {
  width: 4.5rem;
  height: 0.75rem;
  border-radius: 6px;
}

@keyframes profile-skeleton-shimmer {
  100% {
    transform: translateX(100%);
  }
}
</style>
